
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, IconButton, } from '@material-ui/core';
import AnchorHeader from './AnchorHeader';
import Slidebanner from '../home/Slidebanner';
import AnchorAvatar from './AnchorAvatar';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import Apis from '../../network/Apis';
import PreviewTwoItem from '../view/PreviewTwoItem';
import AppUtils from '../../control/apputlis';
import AppData from '../../model/AppData';
import MSectionHeader from '../view/MSectionHeader';
import MAnchor from '../view/MAnchor';
import MStatusBar from '../view/MStatusBar';
import NoMatch from '../home/NoMatch';
import MEnvelope from '../view/MEnvelope';

const ICON_SEARCH = require("../../images/icons/sousuo_icon.png");
const ICON_ZHIBO = require("../../images/icons/zhubo.png");


class AnchorPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            oneTypeData: [],
            data: [],
            matchsData: [],
            anchorRankData: [],
            changeIndex: 0,
            nowHostRecomm: [],
        };
    }

    componentDidMount() {
        this.getRecommType();
        this.getRecommAnchor();
        AppData.checkUpdate();
        AppUtils.YMPush('MAIN', 'AnchorPage');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getRecommAnchor = async () => {
        if (!AppData.recommAnchorData || AppData.recommAnchorData.length == 0) {
            let hostRecomm = await Apis.encryptionHostRecomm();
            if (hostRecomm.code == 200) {
                if (hostRecomm.data && hostRecomm.data.length > 0) {
                    AppData.recommAnchorData = hostRecomm.data;
                }
            }
        }
        let nowHostRecomm = [];
        for (let i = 0; i < AppData.recommAnchorData.length && i < 4; i++) {
            nowHostRecomm.push(AppData.recommAnchorData[i]);
        }
        this.setState({ nowHostRecomm: nowHostRecomm });
    }

    getRecommType = async () => {
        let data = [];
        let localChannels = AppUtils.getStorageObj(AppUtils.CUSTOM_CHANNELS);
        if (localChannels != null) {
            data = localChannels;
        } else {
            let result = await Apis.encryptionRecommType();
            if (result.code == 200) {
                data = result.data;
                AppUtils.setStorageObj(AppUtils.CUSTOM_CHANNELS, data);
            }
        }

        let oneTypeData = [];
        oneTypeData.push({
            id: 0,
            logo: "",
            name: "推荐",
            type_id: 0,
        });
        data.forEach(element => {
            oneTypeData.push(element);
        });
        this.setState({ oneTypeData: oneTypeData });
        if (this.state.tabIndex == 0) {
            this.getLiving();
            this.getAnchorRanking();
        } else {
            this.getRecommLive(data[this.state.tabIndex]);
        }
    }

    getAnchorRanking = async () => {
        let result = await Apis.encryptionHostPaiHang();
        if (result.code == 200) {
            let data = result.data;
            let anchorRankData = [];
            for (let i = 0; i < data.length && i < 3; i++) {
                anchorRankData.push(data[i]);
            }
            this.setState({ anchorRankData: anchorRankData });
        }
    }

    getRecommLive = async (data) => {
        let result = await Apis.encryptionRecommLive(data.id, data.type_id);
        if (result.code == 200) {
            this.setState({ data: result.data });
        }
    }

    getLiving = async (data) => {
        let result = await Apis.encryptionHostLive();
        if (result.code == 200) {
            this.setState({ data: result.data });
        }
    }

    _handleChange = (val) => {
        let { oneTypeData } = this.state;
        for (let i = 0; i < oneTypeData.length; i++) {
            if (val.id == oneTypeData[i].id) {
                this.state.tabIndex = i;
            }
        }
        if (val.id == 0) {
            this.getLiving();
            this.getAnchorRanking();
        } else {
            this.getRecommLive(val);
        }
    }

    _onSearchClick = () => {
        this.props.history.push({ pathname: '/search' });
    }

    _onAnchorRank = () => {
        this.props.history.push({ pathname: '/anchorrank' });
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    _onClickChange = () => {
        let { changeIndex } = this.state;
        let hostRecomm = AppData.recommAnchorData;

        changeIndex++;
        if (changeIndex * 4 >= hostRecomm.length) {
            changeIndex = 0;
        }
        let nowHostRecomm = [];
        let startIdx = changeIndex * 4;
        for (let i = startIdx; i < hostRecomm.length && i < startIdx + 4; i++) {
            nowHostRecomm.push(hostRecomm[i]);
        }
        this.setState({ nowHostRecomm: nowHostRecomm, changeIndex: changeIndex });
    }

    render() {
        const { classes } = this.props;
        const { oneTypeData, data, anchorRankData, tabIndex, nowHostRecomm } = this.state;
        let anchorData = AppUtils.processList(data, 2);
        return (
            <div style={{ flex: 1 }}>
                <div className={classes.topContainer} style={{ zIndex: 1, position: 'relative' }}>
                    <div position='fixed' className={classes.appbar}>
                        <MStatusBar />
                        <Grid container direction='row' alignItems='center'>
                            <ButtonBase onClick={() => this._onSearchClick()}>
                                <img src={ICON_SEARCH} style={{ width: 12, height: 12, marginLeft: 8, marginRight: 8 }}></img>
                            </ButtonBase>
                            <AnchorHeader data={oneTypeData} onChange={(val) => this._handleChange(val)} />
                        </Grid>
                        <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                        {
                            tabIndex == 0 && <Grid container direction='column' alignItems='center'>
                                <Slidebanner />
                                <Grid container direction='row' alignItems='center' justify='space-between'>
                                    <img src={ICON_ZHIBO} style={{ width: 135, height: 35, marginLeft: 8 }}></img>
                                    <ButtonBase className={classes.iconButton} onClick={() => this._onAnchorRank()}>
                                        <Grid container direction='row' alignItems='center' justify='flex-end' style={{ flex: 1 }}>
                                            {
                                                anchorRankData.map((item, i) => (
                                                    <AnchorAvatar key={i} avatar={item.portrait} />
                                                ))
                                            }
                                            <ChevronRightOutlinedIcon className={classes.chevron} />
                                        </Grid>
                                    </ButtonBase>
                                </Grid>
                            </Grid>
                        }
                        <Grid container direction='column' alignItems='center' style={{ marginTop: 16 }}>
                            {
                                anchorData.length > 0 && anchorData.map((item, i) => (
                                    <PreviewTwoItem key={i} data={item} />
                                ))
                            }
                            {
                                anchorData.length == 0 && <Grid>
                                    <Grid container justify='center' alignItems='center' justify='center' style={{ marginTop: 8, marginBottom: 8 }}>
                                        <NoMatch />
                                    </Grid>
                                    <MSectionHeader title={'推荐主播'} subtitle='换一换' chevron={false} onClick={() => this._onClickChange()} />
                                    <Grid container justify='flex-start' direction='row' alignItems='center' style={{ width: '100vw' }}>
                                        {
                                            nowHostRecomm.map((item, n) => (
                                                <Grid key={n} container alignItems='center' style={{ maxWidth: '20vw', marginLeft: 8, marginRight: 8, marginBottom: 16 }}>
                                                    <MAnchor showsbsb={true} data={item} name={item.nickName} avatar={item.portrait} sbusb={AppData.isStarAnchor(item.user_id)} onClick={() => this._onClicAnchor(item)} />
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </Grid>
                            }
                        </Grid>
                        {/* <MEnvelope bottom={123} /> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    topContainer: {
        width: '100vw',
        backgroundColor: 'transparent',
    },
    appbar: {
        width: '100vw',
        backgroundSize: '100% 100%',
        backgroundColor: '#fff',
        backgroundRepeat: 'no-repeat',
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
    },
    chevron: {
        color: '#0D0D0D',
        fontSize: 24,
    }
}))(AnchorPage));